module.exports = __webpack_public_path__ + "56abc05fc472746d23c5858563ac8518.png";